import { defaultNoScenarioDisplayProps } from "./DefaultNoScenarioDisplayProps";
import SelectedScenario from "./SelectedScenario";

import findNextUnusedName from "../UtilityComponents/FormUtilityComponents/findNextUnusedName";

function ScenarioSuggestions(ssl: SelectedScenario[]) {
  const usedNames = ssl ? ssl.map((ss) => ss.params[0].currentModeStates[ss.params[0].currentModeIndex] as string) : [];

  const noPrimaryScenario = ssl ? ssl.every((ss) => !ss.primary) : true;

  const possiblePrimarySuggestionName = findNextUnusedName("3 Year Average Return", usedNames);

  return {
    suggestions: [
      {
        scenario: "Constant Price",
        params: [{ currentModeIndex: 0, currentModeStates: [findNextUnusedName("Constant Price", usedNames)] }],
        currentlyDisplayed: false,
        primary: false,
        scenarioDisplayProps: defaultNoScenarioDisplayProps,
      },
      {
        scenario: "Historical Performance",
        params: [
          { currentModeIndex: 0, currentModeStates: [possiblePrimarySuggestionName] },
          { currentModeIndex: 0, currentModeStates: [3] },
        ],
        currentlyDisplayed: true,
        primary: noPrimaryScenario,
        scenarioDisplayProps: defaultNoScenarioDisplayProps,
      },
      {
        scenario: "Fixed Percent Growth",
        params: [
          { currentModeIndex: 0, currentModeStates: [findNextUnusedName("5% Annual Growth", usedNames)] },
          { currentModeIndex: 0, currentModeStates: [5] },
        ],
        currentlyDisplayed: false,
        primary: false,
        scenarioDisplayProps: defaultNoScenarioDisplayProps,
      },
    ],
    snackbarPrimaryName: noPrimaryScenario ? possiblePrimarySuggestionName.trim() : undefined,
  };
}
export default ScenarioSuggestions;
